export const environment = {
  production: true,
  apiUrl: 'https://tools.rbb-online.de/forms-service',
  zyrusApiUrl: 'https://tools.rbb-online.de/zyrus-service',
  title: 'Forms',
  instance: '',
  authUrl: 'https://tools.rbb-online.de/web-auth-service',
  webUrl: 'https://tools.rbb-online.de/forms',
  dataProtectionOfficer: true,
  transferSystems: [
    {
      name: 'Testsystem',
      url: 'https://tools-t.rbb-online.de/forms-service'
    },
    {
      name: 'Stagesystem',
      url: 'https://tools-s.rbb-online.de/forms-service'
    }
  ]
};
